import { GLOSS_VAULT } from "@bitwarden/web-vault/app/models/constants/global.constants";
import { InstitutionView } from "@bitwarden/web-vault/app/models/view/institution/institution.view";
import { GLOSS_VAULT_INSTITUTION_ID_PREFIX } from "./gloss-vault-institution.helper";
import { isPluginInstitution } from "./plugin-institution.helper";

/** The id-only part of isSelectableCatalogInstitution below: the synthetic plugin and GLOSS Vault
 * institutions have fixed id prefixes, so this works before the catalog has loaded. */
export const isSelectableInstitutionId = (id: string): boolean =>
  !isPluginInstitution({ id }) && !id.startsWith(GLOSS_VAULT_INSTITUTION_ID_PREFIX);

/** Catalog institutions a user can put accounts under by hand (Add Account, or linking a manual
 * institution in institution details). Plugin institutions (e.g. Opal) only get accounts through
 * the plugin flow, and GLOSS Vault only holds GLOSS credits. */
export const isSelectableCatalogInstitution = (
  institution: Pick<InstitutionView, "id" | "name">,
): boolean =>
  isSelectableInstitutionId(institution.id) &&
  // The synthetic GLOSS Vault is caught by id; this is in case the server's list has its own row.
  institution.name !== GLOSS_VAULT;
